<!-- Main container -->
<div class="layout-col full">
  @if (constraints$ | async; as constraints) {
    <elder-table class="flex" matSort [data]="constraints" [selectionVisible]="false">
      <!-- icon -->
      <ng-container matColumnDef="icon">
        <th mat-header-cell *matHeaderCellDef style="width: 5%"></th>
        <td mat-cell *matCellDef="let row">
          <span class="layout-row place-start-center">
            <mat-icon>label</mat-icon>
          </span>
        </td>
      </ng-container>

      <!-- description Column -->
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef style="width: 25%">
          {{ 'context.description' | translate }}
        </th>
        <td mat-cell *matCellDef="let constraint">
          @if (!!constraint.spec) {
            <div class="layout-col">
              <span>{{ constraint?.spec?.description }}</span>
              <span class="text-body-small">{{ constraint?.spec?.property?.id }}</span>
            </div>
          } @else {
            <div class="layout-col">
              <span class="error">{{ 'skillSets.constraints.missingSpec' | translate }}</span>
              <span class="error" class="text-body-small">{{ constraint?.constraintSpecId }}</span>
            </div>
          }
        </td>
      </ng-container>

      <!-- operator Column -->
      <ng-container matColumnDef="operator">
        <th mat-header-cell *matHeaderCellDef style="width: 10%">
          {{ 'skillSets.constraints.operator' | translate }}
        </th>
        <td mat-cell *matCellDef="let constraint">
          @if (!!constraint?.spec?.operator) {
            <div class="layout-col">
              {{ 'ConstraintOperator.' + constraint?.spec?.operator | translate }}
            </div>
          } @else {
            <span class="error">-</span>
          }
        </td>
      </ng-container>

      <!-- value Column -->
      <ng-container matColumnDef="value">
        <th mat-header-cell *matHeaderCellDef>{{ 'context.value' | translate }}</th>
        <td mat-cell *matCellDef="let constraint; let i = index">
          <app-constraint-input
            [name]="name + 'value' + i"
            [value]="constraint"
            [tripleStateBoolean]="tripleStateBoolean"
            (valueUpdated)="onConstraintConfUpdated($event, constraints)"
          >
          </app-constraint-input>
        </td>
      </ng-container>

      <!-- optional Column -->
      <ng-container matColumnDef="optional">
        <th mat-header-cell *matHeaderCellDef style="width: 25%">
          {{ 'context.optional' | translate }}
        </th>
        <td mat-cell *matCellDef="let constraint">
          {{ (constraint?.spec?.matchIfMissingProp ? 'actions.yes' : 'actions.no') | translate }}
        </td>
      </ng-container>
    </elder-table>
  }
</div>
